import { render, staticRenderFns } from "./verify.vue?vue&type=template&id=2d9a50f2&scoped=true&"
import script from "./verify.vue?vue&type=script&lang=js&"
export * from "./verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a50f2",
  null
  
)

export default component.exports